import * as types from "./actionTypes";

const initialState = {

  token: localStorage.getItem("token"),
  isAuthenticated: false,
  loading: false,
  user: null,
  error: null,
  message: null,
};

export const authReducer = (state = initialState, action) => {

  const { type, payload } = action; // Destructure the action object

  switch (type) {

    case types.LOGIN_REQUEST:

    case types.LOAD_USER_REQUEST:

      return {
        ...state,
        loading: true,
      };

    // If the login is successful, set the token, isAuthenticated to true, and clear the error
    case types.LOGIN_SUCCESS:

      return {
        ...state,
        token: payload.token,
        isAuthenticated: true,
        loading: false,
        message: payload.message,
        error: null,
      };

    // If the login is successful, set the token, isAuthenticated to true, and clear the error
    case types.LOAD_USER_SUCCESS:

      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload, // User details from the API response
        error: null,
      };

    case types.LOGIN_FAILURE:

    // If the login fails, clear the token and set isAuthenticated to false
    case types.LOAD_USER_FAILURE:

      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        error: payload,
      };

    // If the logout action is dispatched, clear the token, user, and set isAuthenticated to false
    case types.LOGOUT:

      return {
        ...state,
        token: null,
        isAuthenticated: false,
        user: null,
      };

    // Return the default state if the action type does not match any of the cases
    default:
      return state;
  }
};
